export const BREAKPOINTS = {
  smallWidth: '500px',
  mediumWidth: '800px',
  largeWidth: '1000px'
};

export const MEDIA_BREAKPOINTS = {
  smallerThanSmall: `@media screen and (max-width: ${BREAKPOINTS.smallWidth})`,
  smallerThanMedium: `@media screen and (max-width: ${BREAKPOINTS.mediumWidth})`,
  smallerThanLarge: `@media screen and (max-width: ${BREAKPOINTS.largeWidth})`,
  largerThanSmall: `@media screen and (min-width: ${BREAKPOINTS.smallWidth})`,
  largerThanMedium: `@media screen and (min-width: ${BREAKPOINTS.mediumWidth})`,
  largerThanLarge: `@media screen and (min-width: ${BREAKPOINTS.largeWidth})`
};
